module.exports = __webpack_public_path__ + "static/media/right_caret.a99bd2b4.svg";